import { isNotNil } from './isNotNil';

export type MandateProps<T extends object, K extends keyof T> = T & {
	[TK in K]-?: NonNullable<T[TK]>
}

export const withProperty = <T extends object, K extends keyof T>(obj: T, k: K): obj is MandateProps<T, typeof k> => isNotNil(obj[k]);

export const isPropPresent = <T extends object, K extends keyof T>(k: K) => (obj: T): obj is MandateProps<T, typeof k> => isNotNil(obj[k]);
